module.exports = __webpack_public_path__ + "img/login-page-graphs.179ebfd3.png";